<template>
    <v-container>
      <!-- Stool Exam -->
      <div class="align-center mt-3 pt-2">
        <span
          class="pl-2"
          style="font-size: 20px; font-weight: bold; color: #00a99d"
          >ผลตรวจอื่นๆ (Other)</span
        >
      </div>
      <!-- <v-data-table
        class="elevation-1 my-table-stool mt-4 ml-1"
        style="background-color: #f6f6f6"
        :headers="headers_stoolExam"
        :items="stool_Exam"
        :hide-default-footer="true"
      >
        <template v-slot:item.stoolExam="props">
          <v-textarea
            v-model="props.item.stoolExam"
            flat
            solo
            dense
            hide-details
            placeholder="ระบุค่าผลตรวจ"
            class="ma-2 textfield-sty"
            color="#00A99D"
          ></v-textarea
        ></template>
      </v-data-table> -->
      <v-data-table
        class="elevation-1 my-table mt-4 ml-1"
        style="background-color: #f6f6f6"
        :headers="headers"
        :items="stool_Exam"
        :hide-default-footer="true"
        :items-per-page="999"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="(item,i) in items" :key="i">
              <td 
                v-if="item.checklist && (item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')"
                 style="align-content: baseline;"
              >{{ item.checklist }}</td>
              <td 
                v-if="item.checklist && (item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')"
                colspan="3"
                style="align-content: baseline;"
              >
                <v-textarea
                  v-model="other_list[item.key].result"
                  flat
                  solo
                  dense
                  hide-details
                  placeholder="ระบุผลตรวจ"
                  class="ma-2 textfield-sty"
                  color="#00A99D"
                ></v-textarea>
              </td>
              <td v-if="item.checklist && !(item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')">{{ item.checklist }}</td>
              <td v-if="item.checklist && !(item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')">
                <v-text-field
                  v-model="other_list[item.key].result"
                  flat
                  solo
                  dense
                  hide-details
                  placeholder="ระบุผลตรวจ"
                  class="ma-2 textfield-sty"
                  color="#00A99D"
                  @input="
                    cal_reuslt(
                      item.key,
                      other_list[item.key].result,
                      item.min,
                      item.max,
                      item.normal
                    )
                  "
                  :type="item.type || 'text'"
                ></v-text-field>
              </td>
              <td v-if="item.checklist && !(item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')">{{ item.normal }}</td>
              <td v-if="item.checklist && !(item.checklist === 'Ultrasound whole Abdomen' || item.checklist === 'Ultrasound Lower Abdomen' || item.checklist === 'Ultrasound Upper Abdomen')">
                <v-text-field
                  v-model="other_list[item.key].summary"
                  :readonly="item.normal ? true : false"
                  flat
                  solo
                  dense
                  hide-details
                  placeholder="ระบุผลการสรุป"
                  class="ma-2 textfield-sty"
                  color="#00A99D"
                ></v-text-field>
              </td>
              <td v-if="!item.checklist" colspan="4" style="background-color: #f2fcf5">
                <span class="text-00A99D">{{ item.name }}</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  import { EventBus } from "../../EventBus";
  import HealthCheckCal from "../../services/health_check_cal";

  export default {
    data() {
      return {
        headers: [
          {
            text: "รายการตรวจ",
            align: "center",
            sortable: false,
            value: "checklist",
          },
          {
            text: "ผลตรวจ",
            align: "center",
            sortable: false,
            value: "results",
          },
          {
            text: "ค่าปกติ",
            align: "center",
            sortable: false,
            value: "normal",
          },
          {
            text: "สรุปผล",
            align: "center",
            sortable: false,
            value: "summary",
          },
        ],
        stool_Exam: [
          {
            checklist: "",
            name: "ผลตรวจอื่นๆ (Other) (สารเคมี,โลหะหนัก,สารระเหย)"
          },
          {
            checklist: "IPA (Urine)",
            value: "",
            normal: "<40 mg/L",
            key: "ipa",
            min: 0,
            max: 40,
            type: "number"
          },
          {
            checklist: "Methyl Ethyl Ketone(MEK)",
            value: "",
            normal: "<2 mg/L",
            key: "methyl_ethyl",
            min: 0,
            max: 2,
            type: "number"
          },
          {
            checklist: "Cyclohexane(Cyclohexanol)",
            value: "",
            normal: "<8 mg/L",
            key: "cyclohexane",
            min: 0,
            max: 8,
            type: "number"
          },
          {
            checklist: "Formaldehyde (Formic acid)",
            value: "",
            normal: "<80 mg/g Cr.",
            key: "formaldehyde",
            min: 0,
            max: 80,
            type: "number"
          },
          {
            checklist: "Hippuric acid (Toluene/Thinner)",
            value: "",
            normal: "<1.6 g/g Cr.",
            key: "hippuric_acid",
            min: 0,
            max: 1.6,
            type: "number"
          },
          {
            checklist: "Acetone (Urine)",
            value: "",
            normal: "<25 mg/L",
            key: "acetone",
            min: 0,
            max: 25,
            type: "number"
          },
          {
            checklist: "Xylene (Methy Hippuric acid)",
            value: "",
            normal: "<1.5 g/g Cr.",
            key: "xylene",
            min: 0,
            max: 1.5,
            type: "number"
          },
          {
            checklist: "Benxene (Phenol in urine)",
            value: "",
            normal: "<50 mg/g",
            key: "benzene",
            min: 0,
            max: 50,
            type: "number"
          },
          {
            checklist: "Ethanol (Blood)",
            value: "",
            normal: "<10 mg%",
            key: "ethanol",
            min: 0,
            max: 10,
            type: "number"
          },
          {
            checklist: "n-Hexane (Urine)",
            value: "",
            normal: "<0.40 mg/L",
            key: "hexane",
            min: 0,
            max: 0.40,
            type: "number"
          },
          {
            checklist: "Cyanide (Blood)",
            value: "",
            normal: "<50 mg/L",
            key: "cyanide",
            min: 0,
            max: 50,
            type: "number"
          },
          {
            checklist: "Nikel (Blood)",
            value: "",
            normal: "<10 ug/dL",
            key: "nikel",
            min: 0,
            max: 10,
            type: "number"
          },
          {
            checklist: "Calcium",
            value: "",
            normal: "8.8-10.6 mg/dL",
            key: "calcium",
            min: 8.8,
            max: 10.6,
            type: "number"
          },
          {
            checklist: "Aluminium",
            value: "",
            normal: "<17 ug/dl",
            key: "aluminium",
            min: 0,
            max: 17,
            type: "number"
          },
          {
            checklist: "Manganese(EDTA)",
            value: "",
            normal: "0-10 ug/dl",
            key: "manganese",
            min: 0,
            max: 10,
            type: "number"
          },
          {
            checklist: "CarboxyHemoglobin(Carbon monoxide)",
            value: "",
            normal: "<3.5 %sat",
            key: "carboxyhemoglobin",
            min: 0,
            max: 3.5,
            type: "number"
          },
          {
            checklist: "Lead(Pb in blood)",
            value: "",
            normal: "<10 ug/L",
            key: "lead",
            min: 0,
            max: 10,
            type: "number"
          },
          {
            checklist: "Phosphorus",
            value: "",
            normal: "2.5-4.5 mg/L",
            key: "phosphorus",
            min: 2.5,
            max: 4.5,
            type: "number"
          },
          {
            checklist: "Styrene",
            value: "",
            normal: "",
            key: "styrene",
          },

          {
            checklist: "",
            name: "ตรวจอัลตร้าซาวด์ช่องท้อง"
          },
          {
            checklist: "Ultrasound whole Abdomen",
            value: "",
            normal: "",
            key: "ultrasound_whole_abdomen"
          },
          {
            checklist: "Ultrasound Lower Abdomen",
            value: "",
            normal: "",
            key: "ultrasound_lower_abdomen"
          },
          {
            checklist: "Ultrasound Upper Abdomen",
            value: "",
            normal: "",
            key: "ultrasound_upper_abdomen"
          },
          
          {
            checklist: "",
            name: "ตรวจหาสารบ่งชี้มะเร็ง"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งเต้านม CA-153",
            value: "",
            normal: "0.0-15.0 U/mL",
            key: "ca_153",
            min: 0.0,
            max: 15.0,
            type: "number"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งรังไข่ CA-125",
            value: "",
            normal: "0.0-35.0 U/mL",
            key: "ca_125",
            min: 0.0,
            max: 35.0,
            type: "number"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งตับอ่อนและลำไส้ CA 19-9",
            value: "",
            normal: "0.0-30.0 U/mL",
            key: "ca_19",
            min: 0.0,
            max: 30.0,
            type: "number"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งทางเดินอาหาร CEA",
            value: "",
            normal: "0.0-4.5 ng/mL",
            key: "cea",
            min: 0.0,
            max: 4.5,
            type: "number"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งตับ AFP",
            value: "",
            normal: "0.0-7.0 ng/mL",
            key: "afp",
            min: 0.0,
            max: 7.0,
            type: "number"
          },
          {
            checklist: "ตรวจหาสารบ่งชี้มะเร็งทต่อมลูกหมาก PSA",
            value: "",
            normal: "0.0-4.0 ng/mL",
            key: "psa",
            min: 0.0,
            max: 4.0,
            type: "number"
          },

          {
            checklist: "",
            name: "ตรวจทางสูติ-นารีเวช"
          },
          {
            checklist: "Helicobacter pylori",
            value: "",
            normal: "",
            key: "helicobacter_pylori"
          },
          {
            checklist: "Pap smear",
            value: "",
            normal: "",
            key: "pap_smear"
          },
          {
            checklist: "Thin prep",
            value: "",
            normal: "",
            key: "thin_prep"
          },
          {
            checklist: "",
            name: "สารเคมี"
          },
          {
            checklist: "ระดับสารเมทานอลในปัสสาวะ (Methanol)",
            value: "",
            normal: "<15 mg/L",
            key: "methanol",
            min: 0,
            max: 15,
            type: "number"
          },
          {
            checklist: "ระดับสารเมทิลคลอโรฟอร์มในปัสสาวะ (Methyl Chlorofoeml) ",
            value: "",
            normal: "0.00-0.70 mg/L ",
            key: "methyl_chlorofoeml",
            min: 0.0,
            max: 0.7,
            type: "number"
          },
          {
            checklist: "ระดับสารไดคลอโรมีเทน (Dichloromethane) ",
            value: "",
            normal: ">0.30 mg/L",
            key: "dichloromethane",
            min: 0.30,
            type: "number"
          },
        ],
        other_list:{
          "ipa": {
              "result": "",
              "summary": ""
          },
          "methyl_ethyl": {
              "result": "",
              "summary": ""
          },
          "cyclohexane": {
              "result": "",
              "summary": ""
          },
          "formaldehyde": {
              "result": "",
              "summary": ""
          },
          "hippuric_acid": {
              "result": "",
              "summary": ""
          },
          "acetone": {
              "result": "",
              "summary": ""
          },
          "xylene": {
              "result": "",
              "summary": ""
          },
          "benzene": {
              "result": "",
              "summary": ""
          },
          "ethanol": {
              "result": "",
              "summary": ""
          },
          "hexane": {
              "result": "",
              "summary": ""
          },
          "cyanide": {
              "result": "",
              "summary": ""
          },
          "nikel": {
              "result": "",
              "summary": ""
          },
          "ultrasound_whole_abdomen": {
              "result": "",
              "summary": ""
          },
          "ultrasound_lower_abdomen": {
              "result": "",
              "summary": ""
          },
          "ultrasound_upper_abdomen": {
              "result": "",
              "summary": ""
          },
          "ca_153": {
              "result": "",
              "summary": ""
          },
          "ca_125": {
              "result": "",
              "summary": ""
          },
          "ca_19": {
              "result": "",
              "summary": ""
          },
          "cea": {
              "result": "",
              "summary": ""
          },
          "afp": {
              "result": "",
              "summary": ""
          },
          "psa": {
              "result": "",
              "summary": ""
          },
          "calcium": {
              "result": "",
              "summary": ""
          },
          "aluminium": {
              "result": "",
              "summary": ""
          },
          "manganese": {
              "result": "",
              "summary": ""
          },
          "carboxyhemoglobin": {
              "result": "",
              "summary": ""
          },
          "lead": {
              "result": "",
              "summary": ""
          },
          "phosphorus": {
              "result": "",
              "summary": ""
          },
          "styrene": {
              "result": "",
              "summary": ""
          },
          "helicobacter_pylori": {
              "result": "",
              "summary": ""
          },
          "pap_smear": {
              "result": "",
              "summary": null
          },
          "thin_prep": {
              "result": "",
              "summary": null
          },
          "methanol": {
            "result": "",
            "summary": ""
          },
          "methyl_chlorofoeml": {
            "result": "",
            "summary": ""
          },
          "dichloromethane": {
            "result": "",
            "summary": ""
          }
        },
      };
    },
    created() {
      this.detailAll();
    },
    methods: {
      detailAll() {
        EventBus.$on("detailAll_GetOneForm", (item) => {
          console.log("item", item);
          
          if (item !== undefined && item !== null) {
            this.other_list = item.other_list;
            // this.other2[0].performance = item.treatmentEtc.performance;
            // this.stool_Exam[0].stoolExam = item.treatmentEtc.stoolExam;
          } else {
            this.clear();
          }
        });
      },
      clear() {
        this.other = [
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
          {
            checklist: "",
            results: "",
            normal: "",
            summary: "",
          },
        ];
        // ----------------------
        this.other2[0] = [
          {
            performance: {
              armAndHand: {
                results: "",
                summary: "",
              },
              backAndlegs: {
                results: "",
                summary: "",
              },
            },
          },
        ];
        // ----------------------
        this.stool_Exam[0].stoolExam = "";
        // ----------------------
      },
      cal_reuslt(
        key,
        data,
        min = 0,
        max = 0,
        normal = ""
      ) {
        console.log("aaa", normal);
        console.log("text.includes();", normal.includes("<"));
        
        let result = null;
        if (normal) {
          if (normal.includes("<") || normal.includes(">")) {
            if (normal.includes("<")) {
              this.other_list[`${key}`].summary =
                this.other_list[`${key}`].result.length > 0
                  ? data < max
                    ? "ปกติ"
                    : "ผิดปกติ"
                  : "";
            } else if (normal.includes(">")) {
              if (key === "dichloromethane") {
                this.other_list[`${key}`].summary =
                this.other_list[`${key}`].result.length > 0
                  ? data > min
                    ? "ปกติ"
                    : "ผิดปกติ"
                  : "";
              } else {
                this.other_list[`${key}`].summary =
                this.other_list[`${key}`].result.length > 0
                  ? data > max
                    ? "ปกติ"
                    : "ผิดปกติ"
                  : "";
              }
            }
          } else if (
            data ||
            (data === "" &&
              this.other_list[`${key}`].summary)
          ) {
            result = HealthCheckCal("item_laboratory", data, {
              min: min,
              max: max,
            });
            
            this.other_list[`${key}`].summary =
              this.other_list[`${key}`].result.length < 1
                ? ""
                : result.result;
          }
        }
      },
    },
    beforeDestroy() {
      EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
    },
  };
  </script>
  
  <style scoped>
  @import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
  .my-table thead th {
    background: #00a99d !important;
    color: #ffffff !important;
    &:first-child {
      border-radius: 10px 0 0 0;
    }
    &:last-child {
      border-radius: 0 10px 0 0;
    }
  }
  .my-table-stool thead th {
    background: #00a99d !important;
    color: #ffffff !important;
    &:first-child {
      border-radius: 10px 0 0 0;
    }
    &:last-child {
      border-radius: 10px 10px 0 0;
    }
  }
  .textfield-sty {
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
  }
  .v-data-table-header th {
    font-size: 15px !important;
    font-weight: 500 !important;
  }

  ::v-deep > .v-row-group__header > .text-start > .v-btn {
    display: none;
  }

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
  </style>
  